(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-crosssell-hotspots"] && !Shopify.designMode) return;
  try {
    
  /* Hotspot dot toggle logic */
  document.addEventListener('DOMContentLoaded', () => {
    const allContainers = document.querySelectorAll('[data-crosssell-hotspot]');

    function closeAllPopups() {
      document.querySelectorAll('[data-hotspot-popup]').forEach((p) => p.classList.remove('is-active'));
      document.querySelectorAll('[data-hotspot-dot]').forEach((d) => d.classList.remove('is-active'));
    }

    allContainers.forEach((container) => {
      const dots = container.querySelectorAll('[data-hotspot-dot]');

      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          const id = dot.getAttribute('data-hotspot-dot');
          const popup = container.querySelector(`[data-hotspot-popup="${id}"]`);
          const isOpen = popup.classList.contains('is-active');

          closeAllPopups();

          if (!isOpen) {
            popup.classList.add('is-active');
            dot.classList.add('is-active');
          }
        });
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-hotspot-popup]') && !e.target.closest('[data-hotspot-dot]')) {
        closeAllPopups();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
